import React from 'react';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from '@react-pdf/renderer';

const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  title: {
    marginBottom: 24,
    fontSize: 24,
    textAlign: 'center',
    fontWeight: 'bold',
    fontFamily: 'Times-Bold',
  },
  subtitle: {
    fontSize: 16,
    marginBottom: 14,
    fontFamily: 'Times-Roman',
  },
  textContent: {
    fontSize: 12,
    margin: 2,
    fontFamily: 'Times-Roman',
  },
  image: {
    width: 150,
    height: 150,
    margin: 10,
  },
  imgContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
});

const GeneratePdf = ({ data, img, filteredData }) => {
  let imagesPerRow = 2;
  const capitalizeWords = (str) => {
    return str.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
  };
  return (
    <>
      <Document>
        <Page size="A4" style={styles.body}>
          <Text style={styles.title}>{data.nama_produk}</Text>
          <Text style={styles.subtitle}>Spesifikasi:</Text>
          <Text style={styles.textContent}>
            Jenis Produk: {data.jenis_produk}
          </Text>
          <Text style={styles.textContent}>Dimensi: {data.dimensi}</Text>
          <Text style={styles.textContent}>Daya: {data.daya}</Text>
          <Text style={styles.textContent}>Bahan: {data.bahan}</Text>
          <Text style={styles.textContent}>Fitur: {data.fitur}</Text>
          {Object.entries(filteredData).map(([key, value]) => (
            <Text style={styles.textContent}>
              {capitalizeWords(key)}: {value}
            </Text>
          ))}
        </Page>
        <Page size="A4" style={styles.body}>
          <Text
            style={{
              textAlign: 'center',
              fontWeight: 'bold',
              fontFamily: 'Times-Bold',
              marginBottom: '30',
            }}
          >
            Gambar Produk
          </Text>
          <View
            style={{
              flexDirection: 'row',
              display: 'flex',
              flexWrap: 'wrap',
            }}
          >
            {img.map((image, index) => {
              if ((index + 1) % imagesPerRow === 0) {
                return (
                  <Image key={index} src={image} style={{ width: '50%' }} />
                );
              } else {
                return (
                  <Image key={index} src={image} style={{ width: '50%' }} />
                );
              }
            })}
          </View>
        </Page>
      </Document>
    </>
  );
};

export default GeneratePdf;
